import React, { Component } from 'react';
import { connect } from 'react-redux';
import { appActions } from '../../../../store/modules/app';
import { couponActions } from '../../../../store/modules/coupon';
import withModal from '../../../../lib/hoc/withModal';
import CouponApplyAvailableProductListModal from '../../../../views/coupon/common/modal/CouponApplyAvailableProductListModal';
import { LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';

class CouponApplyAvailableProductListModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      storeId: this.props.data.storeId,
      discountType: this.props.data.discountType,
      minimumPurchasePrice: this.props.data.minimumPurchasePrice,
      discountAmount: this.props.data.discountAmount,
      maxDiscountPrice: this.props.data.maxDiscountPrice,
      exclude24k: this.props.data.exclude24k,
    };
  }

  componentDidMount() {
    this.initiate();
  }

  initiate = () => {
    this.getList({
      pagination: LIST_PAGINATION_MODEL,
    });
  };

  /**
   * 리스트 불러오기
   */
  getList = (option) => {
    const { getCouponApplyAvailableProductList, data } = this.props;
    const { storeId, minimumPurchasePrice, discountAmount, discountType, maxDiscountPrice, exclude24k } = this.state;
    const { pagination } = data.listData;

    getCouponApplyAvailableProductList({
      storeId,
      minimumPurchasePrice,
      discountAmount,
      discountType,
      maxDiscountPrice,
      exclude24k,
      pagination,
      ...option,
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.toggleModal({ name: 'couponApplyAvailableProductListModal', value: false });
  };

  render() {
    const { isOpen, data, getProductSubCategoryList } = this.props;

    return (
      <CouponApplyAvailableProductListModal
        isOpen={isOpen}
        data={data}
        getProductSubCategoryList={getProductSubCategoryList}
        getList={this.getList}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.coupon.couponApplyAvailableProductListModal.isOpen,
    data: state.coupon.couponApplyAvailableProductListModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: couponActions.toggleModal,
  getCouponApplyAvailableProductList: couponActions.getCouponApplyAvailableProductList,
  getProductSubCategoryList: appActions.getProductSubCategoryList,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(CouponApplyAvailableProductListModalContainer));
